import {
  Box,
  Grid,
  ReassignContactCard,
  Typography,
} from '@atgfr8/atg-ui-tailwind';
import { ReassignTypeEnum } from '@common/types';
import { Popover } from '@components';
import {
  fetchUserInfoUserModel,
  orderStore,
  updateLoadPropertyAtIndex,
} from '@store/orders';
import { ILoadEditViewModel } from '@typeDefinitions/loadTypes';
import ReassignCard from '@views/order/components/reassign/ReassignCard';
import { createEffect, Show } from 'solid-js';

import { subTextStyle } from '../styles';
import { loadInfoStore } from './store';
import { handleReassignedUser } from './utils';

type PropsT = {
  load: ILoadEditViewModel;
  tabIndex: number;
};

export const CoveredBy = (props: PropsT) => {
  createEffect(() => {
    if (props.load.coveredById) {
      void fetchUserInfoUserModel(props.load.coveredById).then((response) => {
        updateLoadPropertyAtIndex({
          coveredByEmail: response.email,
        });
      });
    }
  });
  return (
    <div class=" flex bg-[#dfecf2] p-2 rounded-sm max-h-12 min-w-52">
      <Box>
        <Show when={props.load.coveredBy != null}>
          <Popover
            eleName={
              <div class="text-left">
                <div class="text-[#123b50] font-semibold text-xs">
                  Covered By
                </div>
                <Show
                  when={props.load.coveredBy}
                  fallback={
                    <Typography
                      variant="body1"
                      component="div"
                      sxProps={{ textAlign: 'left' }}
                    >
                      -
                    </Typography>
                  }
                >
                  <div class="font-medium">{props.load.coveredBy}</div>
                </Show>
              </div>
            }
            onClick={() => {
              if (props.load.coveredBy != null) {
                void handleReassignedUser(
                  props.load.coveredById as number,
                  ReassignTypeEnum.CoveredBy,
                );
              }
            }}
            sxProps={{
              'text-transform': 'none',
              padding: '0px',
            }}
            class="[&:hover]:bg-none"
          >
            <Box style={{ padding: '8px' }}>
              <ReassignContactCard
                contact={loadInfoStore.coveredBy}
                showIcon
                isLoading={loadInfoStore.isLoading}
              />
            </Box>
          </Popover>
        </Show>
        <Show when={props.load.coveredBy == null}>
          <Grid item>
            <Typography
              variant="body1"
              component="div"
              sxProps={{ ...subTextStyle, textAlign: 'left' }}
            >
              Covered By
            </Typography>
          </Grid>
          <Grid item size={12}>
            <Typography variant="body1" component="div" class="text-left">
              <Typography
                variant="body1"
                component="div"
                sxProps={{ textAlign: 'left' }}
              >
                -
              </Typography>
            </Typography>
          </Grid>
        </Show>
      </Box>
      <div class="mt-3.5 ml-auto">
        <Popover
          classes="px-1 py-0 !h-[24px]"
          eleName={
            <span class=" text-[#026EA1] font-medium text-sm leading-6 tracking-tighter cursor-pointer ">
              REASSIGN
            </span>
          }
          onClick={() => {
            if (orderStore.isReadOnly) {
              return;
            }

            if (props.load.coveredBy != null) {
              void handleReassignedUser(
                props.load.coveredById as number,
                ReassignTypeEnum.CoveredBy,
              );
            }
          }}
        >
          <ReassignCard
            type={'COVERED BY'}
            contactInfo={
              props.load.coveredById != null
                ? loadInfoStore.coveredBy
                : undefined
            }
            isLoading={() => loadInfoStore.isLoading}
            onButtonClick={handleReassignedUser}
          />
        </Popover>
      </div>
    </div>
  );
};
